// The one way a weather or sea card says how old its data is. Reads the result of
// freshnessOf() (src/lib/freshness.js), so every page words and colours it the same.
//
//  - fresh and `live`         → pulsing «En vivo»
//  - fresh and `showWhenFresh`→ quiet «hace 5 min»
//  - stale                    → amber «Hace 3 h»
//  - unavailable              → amber «Sin datos recientes»
//  - unknown (old server, no time at all) → nothing; the card's own source line stands.
const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export default function FreshnessPill({ info, live = false, showWhenFresh = false, className = '', testId }) {
  if (!info || info.status === 'unknown') return null;
  if (info.fresh) {
    if (live) {
      return (
        <span className={`flex items-center gap-1 ${className}`} data-testid={testId}>
          <span className="relative flex h-1.5 w-1.5" aria-hidden="true">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-torre-teal opacity-75" />
            <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-torre-teal" />
          </span>
          <span className="text-[11px] font-bold text-slate-500 uppercase tracking-wider">En vivo</span>
        </span>
      );
    }
    if (!showWhenFresh || !info.label) return null;
    return <span className={`text-[11px] text-slate-400 ${className}`} data-testid={testId}>{info.label}</span>;
  }
  if (!info.label) return null;
  return (
    <span className={`inline-flex items-center text-[11px] text-amber-700 bg-amber-50 px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${className}`}
      data-testid={testId}>
      {cap(info.label)}
    </span>
  );
}
